// A MEGBESZÉLÉS-RÉSZVÉTEL (RSVP) állapot-jelvénye a partner-felületen.
//
// MIÉRT KÖZÖS KOMPONENS: a jelvény két helyen jelenik meg — az Üzenetek lap megbeszélés-kártyáin és a
// kezdőlap „Megbeszélések" kártyájának SORAIN (user-döntés). A jel (szín + ikon) a KÖZÖS
// badge-katalógusból (`domain-badge.tsx`, `rsvp`), a felirat a portál i18n-kulcsaiból — egy helyen dől el.
//
// Az `internal` (belső) felület megbeszélés-lapja SZÁNDÉKOSAN nem ezt használja: ott a részvétel a szervező
// szemszögéből, résztvevő-listaként jelenik meg, nem egyetlen saját válaszként.
import { useTranslation } from 'react-i18next';

import { DomainBadge } from '@/components/shared/domain-badge';

export interface MeetingRsvpBadgeProps {
  rsvp: 'pending' | 'confirmed' | 'declined';
}

export function MeetingRsvpBadge({ rsvp }: MeetingRsvpBadgeProps): JSX.Element {
  const { t } = useTranslation();
  return <DomainBadge kind="rsvp" value={rsvp} label={t(`portal.messages.rsvp.${rsvp}`)} />;
}
